import { Link } from 'react-router-dom';
import { profile } from '../data/profile';
import { projects } from '../data/projects';
import TerminalPrompt from '../components/ui/TerminalPrompt';
import StatCard from '../components/ui/StatCard';
import ProjectCard from '../components/ui/ProjectCard';
import SectionTitle from '../components/ui/SectionTitle';

export default function Home() {
  const featured = projects.filter((p) => p.featured).slice(0, 4);
  const { stats } = profile;

  return (
    <>
      <section className="hero">
        <div className="container hero-grid">
          <div className="hero-content">
            <TerminalPrompt />
            <h1>
              你好，我是 <span className="highlight">{profile.name}</span>
            </h1>
            <p className="tagline">{profile.tagline}</p>
            <p className="bio">
              {profile.bio} · {profile.company} @ 北京
              <br />
              {profile.intro}
            </p>
            <div className="hero-actions">
              <a href={profile.github} className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                → GitHub
              </a>
              <a href={profile.resume} className="btn btn-ghost" target="_blank" rel="noopener noreferrer">
                简历
              </a>
              <Link to="/projects" className="btn btn-ghost">浏览项目</Link>
            </div>
          </div>
          <aside className="avatar-wrap">
            <img src={profile.avatar} alt={`${profile.login} avatar`} width={280} height={280} />
            <div className="avatar-meta">
              <div><strong>{profile.login}</strong></div>
              <div>company :: {profile.company}</div>
              <div>location :: {profile.location}</div>
              <div>since :: {profile.since}</div>
            </div>
          </aside>
        </div>
      </section>

      <section>
        <div className="container">
          <SectionTitle title="数据概览" />
          <div className="stats-grid">
            <StatCard num={stats.repos} label="公开仓库" />
            <StatCard num={stats.followers} label="Followers" />
            <StatCard num={stats.following} label="Following" />
            <StatCard num={stats.gists} label="Gists" />
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <SectionTitle title="精选项目" />
          <div className="projects-grid">
            {featured.map((p) => (
              <ProjectCard key={p.name} {...p} />
            ))}
          </div>
          <p style={{ marginTop: '1.5rem', textAlign: 'center' }}>
            <Link to="/projects" className="btn btn-ghost">查看全部项目 →</Link>
          </p>
        </div>
      </section>
    </>
  );
}
